<template>
    <el-container class="container" style="padding:0">
        <!-- 侧边栏 -->
        <el-aside width="200px" style="background: rgb(246, 248, 251);height:100%">
            <LeftBar :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" />
        </el-aside>
        <!-- 主要内容容器 -->
        <el-container style="position:relative;height:100%;display: flex;flex-direction: column;">
            <el-header style="height: 60px;background: white;display: flex;justify-content: space-between;align-items: flex-end;">
                <div></div>
                <CustomTool style="width:120px;" :column_mapper="column_mapper" :show-time-area="false" :show-time="false" :show-refresh="false" :show-filter="true" :show-export="true" @filters="filterContentChange" @export="exportExcel"/>
            </el-header>
            <div style="height: 100%;padding:20px 0px;overflow: scroll;background:white;">
                <custom-table
                    ref="mytable"
                    :table-id="6"
                    :project-list-dl="tableData.projectList"

                    :show-coloums-dl="tableData.showColoums"
                    :column_mapper="tableData.column_mapper"
                    :sort-column-name-dl="tableData.sortColumnName"
                    :sort-column-order-dl="tableData.sortColumnOrder"

                    @current-change="currentPage"
                    :totalnums-dl="tableData.totalnums"
                    :pagesize-dl="tableData.pagesize"
                    :page-number-dl="tableData.pageNumber"

                    :fixed-columns="tableData.fixedList"

                    :disableDrag="true"

                    :sortable="false"

                    :pagination="tableData.pagination"

                    :is-loading-dl="tableData.detailLoading"
                    :use-virtual="false"
                    :row-hegit="0"
                    :custom-tabel-height-offset="265"
                ></custom-table>
            </div>
        </el-container>
    </el-container>
</template>

<script>
    import LeftBar from "@/component/Bar/leftBar/LeftBar";
    import CustomTable from "@/component/CustomTable";
    import CustomTool from "@/component/Performance/topTool/CustomTool";
    import { getAchievementsInfo, exportAchievements } from '../../api/api';
    export default {
        name: "achievements",
        components: {
            LeftBar,
            CustomTable,
            CustomTool
        },
        data() {
            return {
                column_mapper: {},
                tableData: {
                    detailLoading: false,
                    projectList: [],
                    column_mapper: {},
                    showColoums: [],
                    sortColumnName: "",
                    sortColumnOrder: "",
                    totalnums: 10,
                    pageNumber: 1,
                    fixedList: [],
                    pagesize: 10,
                    pagination: true
                },
                leftItems: [
                    {
                        id: 0,
                        name: "绩效表",
                        key: "achievements"
                    }
                ],
                currentSelectLeftItemKey: "achievements",
                filterRequestData: {},
                filterContent:{
                    queryCond: [],
                    sortCond: {
                    columnName: "",
                    value: ""
                    },
                }
            }
        },

        async mounted() {
            this.refresh()
        },

        methods: {
            filterContentChange(content){
                Object.assign(this.filterContent, content)
                this.refresh()
            },

            async getData(resetPage=false) {
                if(resetPage){
                    this.tableData.pageNumber = 1
                }
                this.filterRequestData = {
                    division:this.currentSelectLeftItemKey,
                    pagiInfo: {
                        currentPage: this.tableData.pageNumber,
                        pagesize: this.tableData.pagesize
                    },
                    ...this.filterContent
                }
                let postData = this.filterRequestData
                let res = await getAchievementsInfo(postData)
                let resData = res.data
                const {respData: {cols_mapper, data , columns_list,totalnums}} = resData
                this.tableData.column_mapper = cols_mapper
                this.tableData.projectList = data
                this.tableData.totalnums = totalnums
                this.tableData.showColoums = columns_list
                this.column_mapper = cols_mapper

                this.$nextTick(() => {
                    this.tableData.detailLoading = false
                })
            },

            async refresh(resetPage=true){
                this.tableData.detailLoading = true
                await this.getData(resetPage)
            },

            async currentPage(e) {
                this.tableData.pageNumber = e;
                this.refresh(false)
            },

            async exportExcel(){
                let param = this.filterRequestData
                let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
                try {
                    let {data} = await exportAchievements(param)
                    loadingInstance.close();
                    const blob = new Blob([data])
                    var date = new Date()
                    let Y = date.getFullYear().toString()
                    let M = (date.getMonth() + 1).toString().padStart(2, "0")
                    let D = date.getDate().toString().padStart(2, "0")
                    let H = date.getHours().toString().padStart(2, "0")
                    let m = date.getMinutes().toString().padStart(2, "0")
                    let s = date.getSeconds().toString().padStart(2, "0")
                    let fileName = '绩效表-' + Y + M + D + H + m + s + ".xlsx"

                    const link = document.createElement('a')
                    link.download = fileName
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob)
                    document.body.appendChild(link)
                    link.click()
                    URL.revokeObjectURL(link.href)
                    document.body.removeChild(link)
                } catch(err) {
                    loadingInstance.close();
                    var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
                    if (issafariBrowser) {
                    this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
                    } else {
                    this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
                    }
                }
            }
        }
    }
</script>
